<script setup lang="ts">
interface SectionProps {
  className?: string;
  title: string;
  subtitle?: string;
}

const props = defineProps<SectionProps>();
</script>

<template>
  <section class="ui-section container" :class="props.className">
    <div class="ui-section__header">
      <h2 class="ui-section__title">
        {{ props.title }}
      </h2>
      <p class="ui-section__subtitle" v-if="props.subtitle">
        {{ props.subtitle }}
      </p>
    </div>
    <slot />
  </section>
</template>

<style scoped lang="scss">
.ui-section {
  display: flex;
  row-gap: fluid(32, 24);
  flex-direction: column;

  &__title {
    font-weight: 600;
    line-height: 125%;
    color: #060606;
    margin-bottom: 0;
  }

  &__header {
    display: flex;
    row-gap: 12px;
    flex-direction: column;
  }

  &__subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #060606;

    @include mobile {
      font-size: 15px;
    }
  }
}
</style>
